import type { LiteralUnion } from "type-fest";

export const partners = [
    "aafes",
    "adt",
    "amazonrouter",
    "asurion",
    "asurionhomeplus",
    "asuriontechcare",
    "att",
    "attconnectedhome",
    "bluestream",
    "brightspeed",
    "cactus",
    "cox",
    "cricket",
    "dell",
    "dish",
    "ee",
    "expertuniversity",
    "fios",
    "frontier",
    "hotwire",
    "hpsales",
    "koodo",
    "leakprotect",
    "liberty",
    "life360",
    "mcafee",
    "mcafeesecurityscan",
    "mediacom",
    "microsoft",
    "nexcom",
    "nrg",
    "optimum",
    "optimumbiz",
    "others",
    "pilot",
    "reach",
    "samsungna",
    "smartpay",
    "sparklight",
    "sparklightsales",
    "staples",
    "stapleshome",
    "staplessmb",
    "telus",
    "telushomepro",
    "thesource",
    "tmobile",
    "tracfone",
    "unknown",
    "uscellular",
    "verizon",
    "verizonconnectedhome",
    "verizonwholeoffice",
    "viasat",
    "vzwsmb",
    "xboxcareplus",
    "yahoo",
    "youtubetv",
] as const;
/** known partner or any string */
export type Partner = LiteralUnion<(typeof partners)[number], string>;
